import React from 'react';
import { useRecoilState } from 'recoil';
import Lz from 'pages/app-profiles/landing-zones/components/Form';
import { Box, Grid, Typography, Paper, Divider } from '@mui/material';
import { landingZoneForm } from 'pages/app-profiles/store';
import { FaTrashAlt } from 'react-icons/fa';
import { MdAdd } from 'react-icons/md';
import LandingZoneStyle from 'pages/app-profiles/landing-zones/LandingZoneStyle';

const SqlFields = () => {
    const [landZoneForm, setLandingZoneForm] = useRecoilState(landingZoneForm);

    const handleAdd = () => {
        const form = { ...landZoneForm };
        try {
            form.vnetSubnet = [
                ...form.vnetSubnet,
                {
                    networkSubscription: null,
                    networkSubscriptionDetails: null,
                    vNet: null,
                    vNetDetails: null,
                    subnet: null,
                    subnetDetails: null,
                },
            ];
        } catch (e) {
            // eslint-disable-next-line
            console.log(e);
        }
        setLandingZoneForm(form);
    };

    const handleDelete = (vnetSubnetToRemove) => {
        const form = { ...landZoneForm };
        const currentVnetSubnet = form?.vnetSubnet;
        const vnetSubnetRemoveIndex = currentVnetSubnet.findIndex((val) => val === vnetSubnetToRemove);
        const vnetSubnet = [...currentVnetSubnet.slice(0, vnetSubnetRemoveIndex), ...currentVnetSubnet.slice(vnetSubnetRemoveIndex + 1)];
        setLandingZoneForm({ ...landZoneForm, vnetSubnet });
    };

    const isDuplicateVnetSubnetValue = (value) => {
        const vnetSubnetValues = landZoneForm?.vnetSubnet?.map((data) => data?.vNet + data?.subnet + data?.networkSubscription);
        const duplicateVnetSubnet = vnetSubnetValues.filter((item, index) => vnetSubnetValues.indexOf(item) !== index);
        if (value) {
            return duplicateVnetSubnet.indexOf(value) > -1;
        }
        return false;
    };

    return (
        <>
            <Grid item xs={6}>
                {' '}
                <Lz.Environments />
            </Grid>
            {/* <Grid item xs={6}>
            {' '}
            <Lz.AppTier />
        </Grid> */}
            <Grid item xs={6}>
                {' '}
                <Lz.Region />
            </Grid>

            <Grid item xs={6}>
                {' '}
                <Lz.Subscription />
            </Grid>

            <Grid item xs={6}>
                {' '}
                <Lz.ResourceGroup />
            </Grid>

            <Grid item xs={6}>
                {' '}
                <Lz.LandingZoneLabel />
            </Grid>
            <Grid item xs={6}>
                {' '}
                <Lz.LandingZoneDesc />
            </Grid>
            <Grid item xs={12} mt={2}>
                <Paper
                    sx={{
                        height: '100%',
                        borderRadius: (theme) => theme.spacing(0.75),
                        marginBottom: (theme) => theme.spacing(3.125),
                        border: '1px solid #E0E0E0',
                    }}
                >
                    <Box display="flex" m={2}>
                        <Typography variant="h1" sx={LandingZoneStyle?.privateEndpoints}>
                            Service Endpoint
                        </Typography>
                    </Box>
                    <Divider />
                    <Box display="flex" m={2}>
                        <Typography sx={LandingZoneStyle?.selectedNetworks}>Selected Networks</Typography>
                    </Box>

                    <Grid container spacing={1.5} ml={1}>
                        <>
                            {landZoneForm?.vnetSubnet?.map((item, index) => (
                                <>
                                    <Grid item xs={10}>
                                        <Lz.NetworkSubscription index={index} />
                                    </Grid>
                                    <Grid item xs={5}>
                                        <Lz.ServiceEndPointVNet index={index} />
                                        {isDuplicateVnetSubnetValue(item?.vNet + item?.subnet + item.networkSubscription) && (
                                            <Grid item xs={12}>
                                                <Typography variant="body2" gutterBottom sx={LandingZoneStyle.vnetSubnetStyle.warningTypography}>
                                                    Duplicate Vnet and Subnet values are not allowed.
                                                </Typography>
                                            </Grid>
                                        )}
                                    </Grid>

                                    <Grid item xs={5}>
                                        <Lz.ServiceEndPointSubNet index={index} />
                                    </Grid>
                                    <Grid item xs={2}>
                                        {index !== 0 && landZoneForm?.vnetSubnet?.length > 1 && (
                                            <Box sx={LandingZoneStyle.vnetSubnetStyle.deleteWrapper} mr={1} ml={1}>
                                                <FaTrashAlt
                                                    style={LandingZoneStyle.vnetSubnetStyle.delete}
                                                    onClick={() => handleDelete(item)}
                                                    className="w-7 h-7 text-red-base cursor-pointer"
                                                    data-testid={`DelBtn-${index}`}
                                                />
                                            </Box>
                                        )}
                                        {index === landZoneForm?.vnetSubnet?.length - 1 && landZoneForm?.vnetSubnet?.length < 5 ? (
                                            <Box sx={LandingZoneStyle.vnetSubnetStyle.addWrapper} ml={1}>
                                                <MdAdd
                                                    style={LandingZoneStyle.vnetSubnetStyle.add}
                                                    onClick={() => handleAdd()}
                                                    className="w-7 h-7 text-blue-base cursor-pointer"
                                                    data-testid={`AddBtn-${index}`}
                                                />
                                            </Box>
                                        ) : (
                                            <span className="w-7 h-7" />
                                        )}
                                    </Grid>
                                    {landZoneForm?.vnetSubnet?.length > 1 && landZoneForm?.vnetSubnet?.length - 1 !== index && (
                                        <Grid item xs={10}>
                                            <Divider variant="horizontal" flexItem xs={{ marginY: 1 }} />
                                        </Grid>
                                    )}
                                </>
                            ))}
                        </>
                    </Grid>
                </Paper>
            </Grid>
        </>
    );
};
export default SqlFields;
